import GsuLoader from '@/components/GsuLoader'
import { PageMetaInfo } from '@/compositions/MetaInfo'
import { FragPageMetaInfo } from '@/compositions/MetaInfo/query'
import type { Props as PageComposerProps } from '@/compositions/PageComposer'
import { FragComposerSections } from '@/compositions/PageComposer/query'
import PageLayout from '@/compositions/PageLayout'
import { queryGsuApi } from '@/service/query'
import { Page } from '@/shared/api-generated-types'
import type { GetServerSideProps, NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import dynamic from 'next/dynamic'
import { gql, useQuery } from 'urql'

const QUERY_SERIES = gql`
  query SeriesPage {
    ${FragComposerSections}
    ${FragPageMetaInfo}
    page: seriesIndexPage {
      title
      id
      metaInfo {
        ...PageMetaInfo
      }
      sections {
        ...CoreSections
        ...RecursiveSections
      }
    }
  }
`

// PageComposer dynamic import to prevent SSR hydration issues
const PageComposerWithLoader = dynamic<PageComposerProps>(() => import('@/compositions/PageComposer'), {
  ssr: false,
  loading: () => <GsuLoader consumeSpace />,
})

const SeriesIndexPage: NextPage<{}> = () => {
  // Fetch page data
  const [{ data, fetching }] = useQuery({
    query: QUERY_SERIES,
    variables: {},
    requestPolicy: 'cache-first',
  })

  // Assign for typing and in-case of no response
  const pageData: Page = data?.page || {}

  return (
    <PageLayout>
      {pageData.metaInfo ? <PageMetaInfo {...pageData.metaInfo} /> : null}
      <PageComposerWithLoader {...pageData} fetching={fetching} />
    </PageLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ locale = 'en-US', req }) => {
  const [urqlState] = await queryGsuApi(QUERY_SERIES, {}, req)
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'series'])),
      urqlState,
    },
  }
}

export default SeriesIndexPage
